<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择产线"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        module="basic"
        :filter.sync="filter"
        url="workLineDetails">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="cname" align="center" label="产线名称"/>
      <el-table-column prop="code" align="center" label="产线代码"/>
      <el-table-column prop="processName" align="center" label="工序"/>
      <el-table-column prop="ccode" align="center" label="工序代码"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";
  export default {
    name:"WorkLineInfoSelect",
    components: {VmSearch, VmTable},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
